<template>
  <div id="contentWrap" class="crpg-t-medical-concierge clear">
    <ComponentsOrganismsMedicalConciergeCommon />
  </div>
</template>

<script>
import ComponentsOrganismsMedicalConciergeCommon from "@/components/organisms/medicalConcierge/MedicalConciergeContent.vue";

export default {
  name: "MedicalConcierge",
  components: {
    ComponentsOrganismsMedicalConciergeCommon,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/templates/medicalConcierge.scss";
</style>
